<template>
  <div class="jobs-body-inspector" style="display: flex; flex-direction: column;">
    <div class="jobs-body-inspector__details">
      <strong>Release Scheduler in {{ details.tenant.text }}:</strong>
      <div class="jobs-body-inspector__job-item">
        <p class="--small-text" style="margin-bottom: 1.5em;">
          You are viewing release labeled: <b>{{  release && release.label ? release.label : 'Loading...' }}</b> <br>
          These are it's notes: <b v-html="release && release.notes ? release.notes : 'Loading...'" /> <br>
          You can select devices and time to to trigger in this flow. <br>
          Please proceed with caution when scheduling device maintenance periods.
        </p>

        <div class="create-job__list-item" style="margin-bottom: 1.5em;">
          <h4 style="margin-right: .25em;">Info:</h4>
          <small style="font-style: italic;">
            Some generic metrics such as display name for better readability of a job.
          </small>
          <br>
          <br>
          <b-input
            style="margin-bottom: 5px; width: 400px;"
            id="job-display-name"
            name="job-display-name"
            v-model="jobObject.displayName" /><br><br>
        </div>

        <div class="create-job__list-item" style="margin-bottom: 2.5em;">
          <h4 style="margin-right: .25em;">When:</h4><br>
          <small style="font-style: italic;">
            This job will occur at this time in the your own timezone. Once it triggers, this job will repeat indefinitely until completed or is deleted.<br>
            Please note, a scheduled time must be a minimum of 15 minutes ahead to account for processing.
          </small>
          <br>
          <br>
          <b-input
            style="margin-bottom: 5px;"
            v-if="!jobObject.scheduledTimeNow && now && (!preloadDeployment || jobObject.scheduledTime)"
            type="datetime-local"
            id="job-time"
            name="job-time"
            :min="now"
            v-model="jobObject.scheduledTime"
            @change="() => {
              const dateString = getLocalTimestampISOString(new Date(), 15);
              if (new Date(dateString).getTime() > new Date(jobObject.scheduledTime).getTime()) {
                jobObject.scheduledTime = dateString;
              }
              if (jobObject.expiration) {
                  if (new Date(getLocalTimestampISOString(new Date(jobObject.scheduledTime), 240)) > new Date(jobObject.expiration)) {
                    jobObject.expiration = getLocalTimestampISOString(new Date(jobObject.scheduledTime), 240)
                  }
                }
            }" />
            <br>
            <input
             type="checkbox"
             id="job-time"
             name="job-time"
            value="now"
            v-model="jobObject.scheduledTimeNow" /> Immediately 
        </div>


        <div class="create-job__list-item" style="margin-bottom: 2.5em;">
          <h4 style="margin-right: .25em;">Expiration:</h4><br>
          <small style="font-style: italic;">
            By default, a job scheduled will never expire. This allows you to set a date that is a hard cut off date for the job. At this time, the job will cancel and all remaining tasks will no longer process.
            <br>Note: This datetime must be at least 4 hours after the scheduled time. 
          </small>
          <br>
          <br>
          <b-input
            style="margin-bottom: 5px;"
            type="datetime-local"
            id="job-expiration-time"
            name="job-expiration-time"
            :min="now"
            v-model="jobObject.expiration"
            @change="() => {
              const dateString = getLocalTimestampISOString(new Date(jobObject.scheduledTime ? jobObject.scheduledTime : new Date() ), 240);
              if (new Date(dateString).getTime() > new Date(jobObject.expiration).getTime()) {
                jobObject.expiration = dateString;
              }
            }" /><br>
          <input
            type="checkbox"
            id="job-time"
            name="job-time"
            :disabled="this.jobObject.expiration === null"
            :checked="this.jobObject.expiration === null"
            @change="(value) => {
              if (value) {
                this.jobObject.expiration = null;
              }
            }" /> No Expiration
        </div>

        <div class="create-job__list-item" style="margin-bottom: 2.5em;">
          <h4 style="margin-right: .25em;">Device Filter:</h4>
          <small style="font-style: italic;">When the job occurs, it will filter for all edge devices that match the model & location selection(s) below. Once it triggers, this job will repeat indefinitely until completed or is deleted.</small><br>
          <br>
          <div class="create-job-select-container" style="margin-bottom: 1em;">
            <multiselect 
              v-model="createConfig.deviceModelSelections" :options="createConfig.deviceModels" :multiple="true"
              @close="generateDeviceFilterDescriptor" @remove="generateDeviceFilterDescriptor" :hideSelected='true'
              placeholder="Select Device Models" class="createJobList" />
          </div>

          <div class="create-job-select-container" style="margin-bottom: 1em;">
            <multiselect 
              v-model="createConfig.deviceSubModelSelections" :options="createConfig.deviceSubModels" :multiple="true"
              @close="generateDeviceFilterDescriptor" @remove="generateDeviceFilterDescriptor" :hideSelected='true'
              placeholder="Select Device Sub Models" class="createJobList" />
          </div>

          <div class="create-job-select-container" style="margin-bottom: 1em;">
            <multiselect 
              v-model="createConfig.deviceIDSelections" :options="createConfig.deviceIDs" :multiple="true"
              @close="generateDeviceFilterDescriptor" @remove="generateDeviceFilterDescriptor" :hideSelected='true'
              placeholder="Select Device IDs" class="createJobList" />
          </div>

          <strong><small style="font-style: italic;">Filter POC(s):</small></strong><br>
          <input @input="searchLocations" style="margin-bottom: 1em;">
          <div style="display: flex; justify-content: space-between; gap: 15em;">
            <div style="min-height: 300px; overflow: auto;" :style="{
              'max-height': `calc(${filterSectionHeight > 300 ? filterSectionHeight : 300}px)`
            }">
              <div style="" v-if="Array.isArray(createConfig.locationTree)" class="create-job-tree-item" v-for="location in createConfig.locationTree" :value="location.id" :key="location.id">
                <p v-if="location.filterMatch"><input @input="selection(location, !location.checked)" v-model="location.checked" type="checkbox"><strong style="margin-right: .25em; margin-left: .25em;">{{ location.name }}:</strong> <span style="font-weight: 300;">{{location.id}}</span></p>
                <div class="create-job-tree-item" v-for="unit in location.children" :value="unit.id" :key="unit.id">
                  <p v-if="unit.filterMatch"><input @input="selection(unit, !unit.checked)" v-model="unit.checked" type="checkbox"><strong style="margin-right: .25em; margin-left: .25em;">{{ unit.name }}:</strong> <span style="font-weight: 300;">{{unit.id}}</span></p>
                  <div class="create-job-tree-item" v-for="area in unit.children" :value="area.id" :key="area.id">
                    <p v-if="area.filterMatch"><input @input="selection(area, !area.checked)" v-model="area.checked" type="checkbox"><strong style="margin-right: .25em; margin-left: .25em;">{{ area.name }}:</strong> <span style="font-weight: 300;">{{area.id}}</span></p>
                  </div>
                </div>
              </div>
            </div>

            <div style="display: flex; flex-direction: column;">
              <div id="jobDescription" style="display: flex; font-size: smaller; font-style: italic; max-width: 300px; min-height: 300px; flex-direction: column;" v-html="deviceFilterDescriptor"></div>
            </div>
          </div>
        </div>

        <div class="create-job__list-item" style="margin-bottom: 1.5em;">
          <div class="jobs-body-inspector__job-item" :style="{ 'background': isCreateValid ? 'rgb(0 255 123 / 5%)' : 'rgb(255 0 0 / 10%)' }">
            <div class="create-job__list-item">
              <div class="create-job__list-item">
                <h5 style="margin-right: .25em;">Preview Job ({{ isCreateValid ? 'Valid' : 'Invalid' }}):</h5> 
                <small style="font-style: italic; margin-bottom: .25em;">When the job occurs, it will process the previewed object below. Once it triggers, this job will repeat indefinitely until completed or is deleted. There are some conditions in which a device may not receive the job immediately such as it offline or it being locked because it is in use or in some other maintenance.</small>

                <h5 style="margin-top: 0.5em;">Job Trigger Time:</h5>
                <strong>{{jobObject.scheduledTimeNow ? 'Immediate' : moment(jobObject.scheduledTime).format("dddd, MMMM Do YYYY, h:mm:ss a")}}</strong>
                
                
                <h5 v-if="Array.isArray(jobObject.prerequisites) && jobObject.prerequisites.length" style="margin-top: 0.5em; margin-bottom: 1em;">Sensors will receive this firmware prior to the job time: (Prerequisites)</h5>
                <div v-if="item" class="jobs-body-inspector__job-item" v-for="(item, index) in jobObject.prerequisites" :value="index" :key="index">
                  <p>
                    <strong style="margin-right: .25em;">Send:</strong> <span style="font-weight: 300;">{{item.key}} ({{item.releaseVersion}})</span>
                  </p>
                  <p>
                    <strong style="margin-right: .25em;">Submodels:</strong> <span style="font-weight: 300;">{{item.subModels}}</span>
                  </p>
                </div>

                <h5 style="margin-top: 1em; margin-bottom: 1em;">Sensors will lock & process at scheduled time: (Tasks)</h5>
                <div class="jobs-body-inspector__job-item" v-for="(item, index) in jobObject.tasks" :value="index" :key="index">
                  <p>
                    <strong style="margin-right: .25em;">Type:</strong> <span style="font-weight: 300;">{{item.type}}</span>
                  </p>
                  <p v-if="item.payload">
                    <strong style="margin-right: .25em;">Payload:</strong> <span style="font-weight: 300;">{{item.payload}}</span>
                  </p>
                </div>

                <h5 style="margin-top: 1em; margin-bottom: 1em;">Devices:</h5>
                <div class="jobs-body-inspector__job-item" v-html="deviceFilterDescriptor" />

                <button v-if="isCreateValid" @click="submitJob()" class="btn-primary btn-margin jobs-body__tab-item--button" style="margin-top: 2.5em; margin-right: .25em; padding: .25em; border-radius: 5px;">
                  Submit Job
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueToast from "vue-toast-notification";
import Loading from "vue-loading-overlay";  
import Multiselect from "vue-multiselect";
import "vue-search-select/dist/VueSearchSelect.css";
import { ModelSelect } from "vue-search-select";
import "vue-loading-overlay/dist/vue-loading.css";
const moment = require("moment");

Vue.use(VueToast);
Vue.use(Loading);
Vue.component("multiselect", Multiselect);

export default {
  name: "DeployJob",
  components: { Multiselect, ModelSelect },
  data() {
    return {
      console: console,
      refreshKey: 0,
      moment: moment,
      validationErrors: [],
      release: null,
      createConfig: {
        locationTree: [],
        selectedAreas: [],
        selectedLocations: [],
        selectedFacilities: [],
        deviceModels: [],
        deviceIDs: [],
        deviceSubModels: [],
        deviceModelSelections: [],
        deviceIDSelections: [],
        deviceSubModelSelections: [],
      },
      jobObject: {
        displayName: '',
        deviceFilter: {
          // Mongo Query
        },
        expiration: null,
        scheduledTime: null, // DateTime -> Will Convert to Cron in Backend
        scheduledTimeNow: null, // DateTime -> Will Convert to Cron in Backend
        tasks: [ // Must have length

        ],
        tenant: null,
        user: {
          id: null,
          first: null,
          last: null,
          email: null,
          phone: null,
        },
        isValid: false,
        template: '',
        silentOptionsSelected: [],
      },
      isCreateValid: false,
      deviceFilterDescriptor: '',
      taskList: [],
      now: this.getLocalTimestampISOString(new Date(), 0),
    };
  },
  watch: { 
    jobObject: {
      deep: true,
      handler (job) { 
        this.isCreateValid = this.isValid({ ...job }).valid;
      }
    },
    createConfig: {
      deep: true,
      handler  () {     
        if (this.createConfig.deviceModelSelections.length) {
          this.jobObject.deviceFilter.model = {
            $in: this.createConfig.deviceModelSelections,
          }
        } else delete this.jobObject.deviceFilter.model;
        if (this.createConfig.deviceSubModelSelections.length) {
          this.jobObject.deviceFilter.subModel = {
            $in: this.createConfig.deviceSubModelSelections,
          }
        } else delete this.jobObject.deviceFilter.subModel;
        if (this.createConfig.deviceIDSelections.length) {
          this.jobObject.deviceFilter.deviceId = {
            $in: this.createConfig.deviceIDSelections,
          }
        } else delete this.jobObject.deviceFilter.deviceId;
        if (this.createConfig.selectedAreas.length || this.createConfig.selectedFacilities.length || this.createConfig.selectedLocations.length) {
          this.jobObject.deviceFilter['$or'] = [];
          if (this.createConfig.selectedFacilities.length) {
            this.jobObject.deviceFilter['$or'].push({
              location: {
                $in: this.createConfig.selectedFacilities.map(item => item.id)
              }
            });
          }
          if (this.createConfig.selectedAreas.length) {
            this.jobObject.deviceFilter['$or'].push({
              area: {
                $in: this.createConfig.selectedAreas.map(item => item.id)
              }
            });
          }
          if (this.createConfig.selectedLocations.length) {
            this.jobObject.deviceFilter['$or'].push({
              unit: {
                $in: this.createConfig.selectedLocations.map(item => item.id)
              }
            });
          }
        }
        if (this.createConfig.selectedFacilities.length) {
          this.jobObject = { ...this.jobObject };
        }
        this.isCreateValid = this.isValid({ ...this.jobObject }).valid;
      }
    },
  },
  mounted() {
    const { release, tenant } = JSON.parse(JSON.stringify(this.details));
    this.release = release;
    this.jobObject.tasks = this.release.job;
    this.jobObject.prerequisites = this.release.prerequisites;
    this.jobObject.displayName = `${tenant.value} `;
    if (this.release && this.release.label) {
      this.jobObject.displayName += `- ${this.release.label} `;
      this.jobObject.template = this.release.label;
    }
    if (this.preloadDevices) {
      this.createConfig.deviceIDSelections = this.preloadDevices;
      this.jobObject.deviceFilter.deviceId = {
        $in: this.createConfig.deviceIDSelections,
      }
      this.deviceFilterDescriptor = `<b>${this.generateDeviceSlug()}</b><br> ${this.generateLocationSlug()}</b> <br><br>`;
      this.$forceUpdate();
    }
    this.fetchCreationConfiguration().then(() => {
      this.getLocations().then(() => {
        if (this.preloadDeployment) {
          const fifteenAhead = this.getLocalTimestampISOString(new Date(), 15);
          if (this.preloadDeployment.scheduledTimeStamp === 'ASAP') {
            this.preloadDeployment.scheduledTimeNow = true;
          } else {
            if ((this.preloadDeployment.scheduledTimeUTC && new Date(fifteenAhead).getTime() > new Date(this.preloadDeployment.scheduledTimeUTC).getTime()) || (this.preloadDeployment.scheduledTimeStamp && new Date(this.preloadDeployment.scheduledTimeStamp).getTime() < new Date(fifteenAhead).getTime())) {
              this.preloadDeployment.scheduledTime = fifteenAhead;
            } else {
              this.preloadDeployment.scheduledTime = this.getLocalTimestampISOString(new Date(this.preloadDeployment.scheduledTimeStamp), 0);
            }
          }
          this.jobObject = this.preloadDeployment;
          this.jobObject.tasks = this.release.job;
          this.jobObject.prerequisites = this.release.prerequisites;
          const deviceFilter = this.preloadDeployment.deviceFilter;
          this.jobObject.deviceFilter = JSON.parse(deviceFilter.replace(/\\/g, ""));
          if (this.jobObject && this.jobObject.deviceFilter) {
            if (this.jobObject.deviceFilter.deviceId) {
              this.createConfig.deviceIDSelections = this.jobObject.deviceFilter.deviceId.$in;
            }
            if (Array.isArray(this.jobObject.deviceFilter.$or)) {
              const locations = this.jobObject.deviceFilter.$or.find((item) => item.hasOwnProperty('location'));
              const units = this.jobObject.deviceFilter.$or.find((item) => item.hasOwnProperty('unit'));
              const areas = this.jobObject.deviceFilter.$or.find((item) => item.hasOwnProperty('area'));
              const allLocations = [];
              const allUnits = [];
              const allAreas = [];
              this.createConfig.locations.forEach((loc) => {
                allLocations.push(loc);
                if (Array.isArray(loc.units)) {
                  loc.units.forEach((unit) => {
                    allUnits.push(unit);
                    if (Array.isArray(unit.areas)) {
                      unit.areas.forEach((area) => {
                        allAreas.push(area);
                      })
                    }
                  })
                }
              })
              if (locations) {
                this.createConfig.selectedFacilities = locations.location.$in.map((item) => {
                  return allLocations.find((loc) => loc.locationId === item);
                });
              }
              if (units) {
                this.createConfig.selectedLocations = units.unit.$in.map((item) => {
                  return allUnits.find((unit) => unit.id === item);
                });
              }
              if (areas) {
                this.createConfig.selectedAreas = areas.area.$in.map((item) => {
                  return allAreas.find((area) => area.id === item);
                });
              }
            }
            if (this.jobObject.deviceFilter.subModel) {
              this.createConfig.deviceSubModelSelections = this.jobObject.deviceFilter.subModel.$in;
            }
            if (this.jobObject.deviceFilter.model) {
              this.createConfig.deviceModelSelections = this.jobObject.deviceFilter.model.$in;
            }
          }
          this.deviceFilterDescriptor = `<b>${this.generateDeviceSlug()}</b><br> ${this.generateLocationSlug()}</b> <br><br>`;
          this.$forceUpdate();
        }
        this.prepareLocationTree();
      });
    });
  },
  methods: {
    padZero(number) {
        return number < 10 ? '0' + number : number;
    },

    getLocalTimestampISOString(baseTime = new Date(), minutesDiff) {
        const futureDate = new Date(baseTime.getTime() + minutesDiff * 60000);

        const year = futureDate.getFullYear();
        const month = this.padZero(futureDate.getMonth() + 1);
        const day = this.padZero(futureDate.getDate());
        const hours = this.padZero(futureDate.getHours());
        const minutes = this.padZero(futureDate.getMinutes());

        return `${year}-${month}-${day}T${hours}:${minutes}`;
    },

    async fetchCreationConfiguration() {
      this.job = null;
      if (!this.$auth.isAuthenticated) {
        return;
      }
      const { tenant } = JSON.parse(JSON.stringify(this.details));
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var request = new Request(
        // eslint-disable-next-line no-undef
        config.OPERATIONS_SERVICE + `/tenants/${tenant.value}/sensors/jobs/create-configuration`, 
        {
          method: 'GET',
          mode: 'cors',
          cache: 'default',
          withCredentials: true,
          credentials: 'include',
          headers: {
            Authorization: 'Bearer ' + id_token,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );

      // Attempt to get Gateways
      try {
        const response = await fetch(request);
        if (response.status === 403) {
          Vue.$toast.open({
            message: "Uh oh... You don't have the permission required to access this resource",
            type: 'error',
          });
          return;
        }
        if (response.status == 401) {
          Vue.$toast.open({
            message: 'Your session has expired please login again to continue',
            type: 'error',
          });
          return;
        }
        if ([502, 503, 500].includes(response.status)) {
            return this.fetchCreationConfiguration();
          }
        if (response.status != 200) {
          Vue.$toast.open({
            message: 'Unable to get data',
            type: 'error',
          });
          return;
        } else {
          // GET
          const res = JSON.parse(JSON.stringify(await response.json()));
          const deviceSet = new Set();
          const deviceSubModelSet = new Set();
          const deviceIDSet = new Set();
          res.deviceModels.forEach((device) => {
            if (device && device.length) {
              const val = device.trim();
              deviceSet.add(val)
            }
          });
          res.deviceIDs.forEach((device) => {
            if (device && device.length) {
              const val = device.trim();
              deviceIDSet.add(val)
            }
          });
          res.deviceSubModels.forEach((device) => {
            if (device && device.length) {
              const val = device.trim();
              deviceSubModelSet.add(val)
            }
          });
          Array.from(deviceSet).forEach((device) => this.createConfig.deviceModels.push(device));
          Array.from(deviceIDSet).forEach((device) => this.createConfig.deviceIDs.push(device));
          Array.from(deviceSubModelSet).forEach((device) => this.createConfig.deviceSubModels.push(device));
          this.createConfig.applications = res.applications;
          this.createConfig.supportedWifiSecurity = res.supportedWifiSecurity;
        }
      } catch (tex) {
        Vue.$toast.open({message: 'Failed to get jobs due to an error.', type: 'error'});
      }
    },

    async getLocations() {
      this.locationList = [];
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      const { tenant } = JSON.parse(JSON.stringify(this.details));
      const url =
        // eslint-disable-next-line no-undef
        config.API_GATEWAY +
        `/location/userLocations?tenantName=${tenant.value}`;
        const getLocation = new Request(url, {
        method: "GET",
        mode: "cors",
        cache: "default",
        withCredentials: true,
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json"
        }
      });
      try {
        const response = await fetch(getLocation);
        if ([500, 502, 503].includes(response.status)) {
          return this.getLocations();
        }
        this.createConfig.locations = await response.json();
      } catch {
        null
      }
    },

    async prepareLocationTree() {
      this.createConfig.locations.forEach((location) => {
        this.createConfig.locationTree.sort((a, b) => a.name.localeCompare(b.name)).push(JSON.parse(JSON.stringify({
          id: location.locationId,
          type: 'location',
          name: location.name,
          checked: this.createConfig.selectedFacilities.find(item => item.locationId === location.locationId),
          filterMatch: true,
          children: Array.isArray(location.units) ? location.units.sort((a, b) => a.name.localeCompare(b.name)).map((unit) => {
            return {
              id: unit.id,
              type: 'unit',
              name: unit.name,
              checked: this.createConfig.selectedLocations.find(item => item.id === unit.id),
              filterMatch: true,
              children: Array.isArray(unit.areas) ? unit.areas.sort((a, b) => a.name.localeCompare(b.name)).map((area) => {
                return {
                  id: area.id,
                  type: 'area',
                  name: area.name,
                  checked: this.createConfig.selectedAreas.find(item => item.id === area.id),
                  filterMatch: true,
                };
              }) : []
            };
          }) : []
        })));
      })
    },

    async searchLocations(val) {
      const value = val && val.target && val.target.value && val.target.value.length ? val.target.value : null;
      if (this.createConfig && this.createConfig.locationTree) {
        this.createConfig.locationTree.forEach((level) => {
          this.recurseSearch(level, value, []);
        });
      }
    },

    recurseSearch(level, val, parents = [], parentMatches = false) {
      level.filterMatch = false;
      parents.push(level);
      if (!val) {
        level.filterMatch = true;
      }
      if (!level.filterMatch && (level.name.toLowerCase().includes(val.toLowerCase()) || level.id.toLowerCase().includes(val.toLowerCase()))) {
        level.filterMatch = true;
      }
      if (level.filterMatch || parentMatches) {
        parents.forEach((parent) => parent.filterMatch = true);
        parentMatches = true;
      }
      if (Array.isArray(level.children)) {
        level.children.forEach((item) => {
          this.recurseSearch(item, val, [...parents], parentMatches);
        })
      }
    },

    selection(selection, newState, parents = [], items = this.createConfig.locationTree, found = false) {
      items.forEach((item) => {
        let localParents = [...parents, item];
        let localFound = found ? found : false;
        if (selection.id === item.id) {
          localFound = true;
          if (!newState) {
            localParents.forEach((item) => item.checked = newState);
          }
        }
        if (localFound) item.checked = newState;
        if (item.children) {
          this.selection(selection, newState, localParents, item.children, localFound);
        }
      });
      this.generateDeviceFilterDescriptor();
    },

    isValid(job) {
      let res = {
        valid: true,
        failed: [],
      };
      
      if (!job) {
        res.failed.push('Job not valid');
      } else {
        if (
          (
            !job.scheduledTime 
            || (new Date(job.scheduledTime) === "Invalid Date") 
          )
          && !job.scheduledTimeNow
        ) res.failed.push('Job time is invalid');
        if (!job.deviceFilter || !Object.keys(job.deviceFilter).length) res.failed.push('Job device filters are invalid');
      }

      if (res.failed.length > 0) {
        res.failed.forEach((failMessage) => {
          if (!this.validationErrors.includes(failMessage)) {
            this.validationErrors.push(failMessage);
          }
        })
        res.valid = false;
      } else {
        this.validationErrors.forEach((err, i) => {
          const index = res.failed.indexOf(err);
          if (index === -1) {
            this.validationErrors.splice(i, 1);
          }
        })
        this.validationErrors.length = 0;
      }

      return res;
    },  

    generateDeviceSlug() {
      let slug = "(These must be true)<br>";
      if (Array.isArray(this.createConfig.deviceModelSelections) && this.createConfig.deviceModelSelections.length) {
        slug += `The following models: ${this.createConfig.deviceModelSelections.join(', ')}.<br>`;
      }
      if (Array.isArray(this.createConfig.deviceSubModelSelections) && this.createConfig.deviceSubModelSelections.length) {
        slug += `The following subModels: ${this.createConfig.deviceSubModelSelections.join(', ')}.<br>`;
      }
      if (Array.isArray(this.createConfig.deviceIDSelections) && this.createConfig.deviceIDSelections.length) {
        slug += `The following device ids: ${this.createConfig.deviceIDSelections.join(', ')}.<br>`;
      }
      if (slug === '(These must be true)<br>') {
        slug = 'All devices';
      }
      return slug;
    },

    generateLocationSlug() {
      let slug = "";
      if (Array.isArray(this.createConfig.selectedFacilities) && this.createConfig.selectedFacilities.length) {
        slug += `In the following facilities <b>${this.createConfig.selectedFacilities.map((item) => item.name).join(', ')}</b>`;
      }
      if (Array.isArray(this.createConfig.selectedLocations) && this.createConfig.selectedLocations.length) {
        if (slug) slug += ' or ';
        slug += `In the following areas <b>${this.createConfig.selectedLocations.map((item) => item.name).join(', ')}</b>`;
      }
      if (Array.isArray(this.createConfig.selectedAreas) && this.createConfig.selectedAreas.length) {
        if (slug) slug += ' or ';
        slug += `In the following locations <b>${this.createConfig.selectedAreas.map((item) => item.name).join(', ')}</b>`;
      }

      if (!slug) {
        slug += 'In this tenant.';
      }
      return slug;
    },

    generateDeviceFilterDescriptor() {
      this.deviceFilterDescriptor = '';
      this.createConfig.selectedFacilities = [];
      this.createConfig.selectedLocations = [];
      this.createConfig.selectedAreas = [];
      if (Array.isArray(this.createConfig.locationTree)) {
        this.createConfig.locationTree.forEach((fac) => {
          if (fac.checked) {
            this.createConfig.selectedFacilities.push({...fac});
          }
          fac.children.forEach((uni) => {
            if (uni.checked) {
              this.createConfig.selectedLocations.push({...uni});
            }
            uni.children.forEach((area) => {
              if (area.checked) {
                this.createConfig.selectedAreas.push({...area});
              }
            });
          });
        });
      } 
      this.createConfig.selectedFacilities.sort((a, b) => a.name.localeCompare(b.name));
      this.createConfig.selectedLocations.sort((a, b) => a.name.localeCompare(b.name));
      this.createConfig.selectedAreas.sort((a, b) => a.name.localeCompare(b.name));
      this.deviceFilterDescriptor = `<b>${this.generateDeviceSlug()}</b><br> ${this.generateLocationSlug()}</b> <br><br>`;
    },

    async submitJob() {
      const { release } = JSON.parse(JSON.stringify(this.details));
      if (this.preloadDeployment && this.preloadDeployment.cancelOnSubmit) {
        alert('You are editing a job. The current job will be cancelled and a new one will be made to the specification provided.')
      }

      const result = confirm("Are you sure you want to submit this job? Please review carefully.");

      if (result) {
        const { tenant } = JSON.parse(JSON.stringify(this.details));

        const payload = {
          deviceFilter: this.jobObject.deviceFilter,
          scheduledTime: this.jobObject.scheduledTimeNow ? 'now' : moment(new Date(this.jobObject.scheduledTime)).toISOString(),
          expiration: this.jobObject.expiration ? new Date(this.jobObject.expiration) : null,
          displayName: this.jobObject.displayName,
          tasks: this.jobObject.tasks,
          prerequisites: this.jobObject.prerequisites,
          tenant: tenant.value,
          template: release.label,
          templateId: release._id,
        }

        if (!this.$auth.isAuthenticated) {
          return;
        }

        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        var request = new Request(
          // eslint-disable-next-line no-undef
          config.OPERATIONS_SERVICE + `/tenants/${tenant.value}/sensors/jobs`, 
          {
            method: 'POST',
            mode: 'cors',
            cache: 'default',
            withCredentials: true,
            credentials: 'include',
            body: JSON.stringify(payload),
            headers: {
              Authorization: 'Bearer ' + id_token,
              'Accept': 'application/json',
              'Content-Type': 'application/json',
            },
          }
        );

        // Attempt to POST Job
        try {
          const response = await fetch(request);
          if (response.status === 403) {
            Vue.$toast.open({
              message: "Uh oh... You don't have the permission required to access this resource",
              type: 'error',
            });
            return;
          }
          if (response.status == 401) {
            Vue.$toast.open({
              message: 'Your session has expired please login again to continue',
              type: 'error',
            });
            return;
          }
          if (response.status == 502) {
              return this.submitJob();
          }
          if (response.status != 200) {
            Vue.$toast.open({
              message: 'Unable to get data',
              type: 'error',
            });
            return;
          } else {
            // GET
            await response.json();

            if (this.preloadDeployment && this.preloadDeployment.cancelOnSubmit && this.preloadDeployment.sensorJobRequestId) {
              if (Array.isArray(this.preloadDeployment.children)) {
                this.preloadDeployment.children.forEach(async (child) => {
                  if (!['cancelled', 'completed', 'expired'].includes(child.state)) {
                    await fetch(new Request(
                      // eslint-disable-next-line no-undef
                      config.OPERATIONS_SERVICE + `/tenants/${tenant.value}/sensors/jobs/${child.sensorJobRequestId}`, 
                      {
                        method: 'DELETE',
                        mode: 'cors',
                        cache: 'default',
                        withCredentials: true,
                        credentials: 'include',
                        headers: {
                          Authorization: 'Bearer ' + id_token,
                          'Accept': 'application/json',
                          'Content-Type': 'application/json',
                        },
                      }
                    ));
                  }
                });
              } else {
                await fetch(new Request(
                  // eslint-disable-next-line no-undef
                  config.OPERATIONS_SERVICE + `/tenants/${tenant.value}/sensors/jobs/${this.preloadDeployment.sensorJobRequestId}`, 
                  {
                    method: 'DELETE',
                    mode: 'cors',
                    cache: 'default',
                    withCredentials: true,
                    credentials: 'include',
                    headers: {
                      Authorization: 'Bearer ' + id_token,
                      'Accept': 'application/json',
                      'Content-Type': 'application/json',
                    },
                  }
                ));
              }
            }
            alert('Job deployed.');
            
            this.$emit('return');
          }
        } catch (tex) {
          Vue.$toast.open({message: 'Failed to get jobs due to an error.', type: 'error'});
        }
      }
    },
  },
  computed: {
    filterSectionHeight() {
      this.refreshKey;
      const filterSectionDOM = document.getElementById("jobDescription");
      return filterSectionDOM ? filterSectionDOM.offsetHeight : 0;   
    },
  },
  props: ["details", 'return', 'preloadDevices', 'preloadDeployment'],
};
</script>

<style lang="scss" scoped>
  .jobs-body-inspector {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    flex: 50%;
    padding: .75em;
    border-radius: .25em;
    border: 1px solid #f1f1f1;

    small {
      display: 'inline-block';
    }

    &__header {
      width: 100%;
    }

    &__details {
      display: flex;
      font-size: smaller;
      color: #484848;
      flex: 1;
      flex-direction: column;
      /*margin-top: 1em; */
    }

    &__job-item {
      display: flex;
      flex-direction: column;
      margin: .75em 0;
      padding: 15px;
      border-radius: 3px;
      border: 1px solid rgba(0, 0, 0, .05);
      background: rgba(0, 0, 0, .03);
      

      p, .create-job__list-item {
        margin: 0;
      }

      strong {
        min-width: 15em;
        display: inline-block;
      }

      span {
        font-size: .90em;
      }
    }

    input, .create-job-select-container {
      border: 1px solid #f1f1f1;
    }

    .-small-text {
      font-size: .9em;
    }

    .create-job-tree-item {
      margin-left: 1em;
    }
  }
</style>